import React, { useEffect } from 'react';
import {
  useLottieAnimation,
  LottieComponentProps,
} from '@leagueplatform/lottie';
import { usePrefersReducedMotion } from '@leagueplatform/web-common';
import { Box } from '@leagueplatform/genesis-core';

const animationData = import('assets/lottie/celebration-confetti.lottie.json');

interface RewardsAnimationComponentProps extends LottieComponentProps {
  shouldPlay?: boolean;
}

export default function CelebrationConfettiAnimation({
  animationRef,
  lottieConfig: configOverrides,
  shouldPlay,
}: RewardsAnimationComponentProps) {
  const prefersReducedMotion = usePrefersReducedMotion();

  const lottieConfig = {
    loop: false,
    autoplay: shouldPlay,
    ...configOverrides,
  };
  const { animationContainerRef, animation } = useLottieAnimation({
    lottieConfig,
    animationRef,
    animationData,
  });

  useEffect(() => {
    if (shouldPlay) {
      animation?.goToAndPlay(0);
    }
  }, [shouldPlay, animation]);

  return prefersReducedMotion ? null : (
    <Box css={{ opacity: shouldPlay ? 1 : 0 }} ref={animationContainerRef} />
  );
}
